import { Box, DashboardModule, SidebarModalListItem } from '@domain-group/suit-theme'

import type { TemplatePageModel } from '@models/types'

interface TemplatePageDetailsProps {
  templatePage: TemplatePageModel,
}

const TemplatePageDetails = (props: TemplatePageDetailsProps) => {
  const { templatePage: { id, title } } = props

  return (
    <DashboardModule title="Details">
      <Box flexDirection="column" paddingX="large">
        <SidebarModalListItem title={title} secondaryText={`Template Page ID #${id}`} />
      </Box>
    </DashboardModule>
  )
}

export default TemplatePageDetails
